import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { CartProvider } from './contexts/CartContext'
import { LanguageProvider } from './contexts/LanguageContext'
import Home from './pages/Home'
import Admin from './pages/Admin'
import Cart from './pages/Cart'
import CustomSiteBuilder from './pages/CustomSiteBuilder'
import StudentApplication from './pages/StudentApplication'
import './App.css'

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/sepet" element={<Cart />} />
            <Route path="/ozel-site-olustur" element={<CustomSiteBuilder />} />
            <Route path="/ogrenci-basvuru" element={<StudentApplication />} />
          </Routes>
        </Router>
      </CartProvider>
    </LanguageProvider>
  )
}

export default App
